import { DeleteOutline, Visibility } from '@mui/icons-material';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableRow,
} from '@mui/material';
import {
  StyledBox,
  StyledHeaderCell,
  StyledTableCell,
  StyledTableHead,
} from './styles';

interface DataTableProps {
  headers: string[];
  rows: any[];
  minWidthTable?: number;
  onView?: (id: string) => void;
  onDelete?: (id: string) => void;
}

const DataTable: React.FC<DataTableProps> = ({
  headers,
  rows,
  minWidthTable,
  onView,
  onDelete,
}) => {

  const isDateValidOrFuture = (dateString: string) => {
    if (!dateString) return false;

    const [day, month, year] = dateString.split('/');
    const formattedDate = new Date(`${year}-${month}-${day}`);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    formattedDate.setHours(0, 0, 0, 0);

    return formattedDate >= today;
  };

  return (
    <StyledBox>
      <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
        <Table sx={{ minWidth: minWidthTable }} aria-label="simple table">
          <StyledTableHead>
            <TableRow>
              {headers.map((header, index) => (
                <StyledHeaderCell key={index}>{header}</StyledHeaderCell>
              ))}
              <StyledHeaderCell />
            </TableRow>
          </StyledTableHead>

          <TableBody>
            {rows.map((row, rowIndex) => {
              const isValid = isDateValidOrFuture(row.vencimento);

              return (
                <TableRow key={rowIndex}>
                  <StyledTableCell
                    sx={{
                      maxWidth: 180,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    title={row.cliente}
                  >
                    {row.cliente}
                  </StyledTableCell>
                  <StyledTableCell>{row.document}</StyledTableCell>
                  <StyledTableCell
                    sx={{
                      maxWidth: 180,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    title={row.equipamento}
                  >
                    {row.equipamento}
                  </StyledTableCell>

                  <StyledTableCell>{row.numSerie}</StyledTableCell>
                  <StyledTableCell>{row.marca}</StyledTableCell>
                  <StyledTableCell>{row.tecnico}</StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontWeight: 600,
                      color: isValid ? 'green' : 'red',
                    }}
                  >
                    {row.vencimento}
                  </StyledTableCell>

                  <StyledTableCell
                    sx={{ display: 'flex', justifyContent: 'center' }}
                  >
                    <IconButton
                      color="primary"
                      onClick={() => onView?.(row.customerId)}
                    >
                      <Visibility />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => onDelete?.(row.customerId)}
                    >
                      <DeleteOutline />
                    </IconButton>
                  </StyledTableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </StyledBox>
  );
};

export default DataTable;
